import { render, staticRenderFns } from "./CbsSheetCell.vue?vue&type=template&id=64acb0e0&scoped=true"
import script from "./CbsSheetCell.vue?vue&type=script&lang=js"
export * from "./CbsSheetCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64acb0e0",
  null
  
)

export default component.exports